import type { RootState } from 'state';
import type { RoutesFiltersState } from '../slice';

function getCarrier(state: RootState): RoutesFiltersState['carrier'] {
  const { carrier } = state.flightRoutes.filtersValues;
  return carrier;
}

export default getCarrier;
